import { PRICE_TYPES_OPTION } from "pages/price-management/Prices/variables";

export const isFieldsForTypeValid = values => {
  const { type, name, registrationCategory, depots } = values;
  switch (type) {
    case PRICE_TYPES_OPTION.DEFAULT:
      return type && name && registrationCategory;
    case PRICE_TYPES_OPTION.DEPOT:
      return type && name && registrationCategory && depots?.length;
    case PRICE_TYPES_OPTION.CONSUMPTION_BAND:
      const { consumptionBand } = values;
      return type && name && consumptionBand && depots?.length;
    case PRICE_TYPES_OPTION.CUSTOMER_GROUP:
      const { customerGroup } = values;
      return type && name && customerGroup;
    default:
      return false;
  }
};
